export const FRAME_PRODUCT_LINES = ['EURO DESIGN 70', 'SYNEGO MD', 'GENEO', 'SLINOVA SLIDE', 'SYNEGO SLIDE', 'GENEO Lift & Slide'] as const

// Retired choices remain readable on existing configurations and snapshots,
// but must not be offered as replacements or selected on new Openings.
export const LEGACY_FRAME_PRODUCT_LINES = ['EURO DESIGN SLIDE'] as const
export type FrameProductLine = typeof FRAME_PRODUCT_LINES[number] | typeof LEGACY_FRAME_PRODUCT_LINES[number]

export function frameProductLineChoices(current?: string | null): readonly string[] {
  const legacy = LEGACY_FRAME_PRODUCT_LINES.find(value => value === current)
  return legacy
    ? [legacy, ...FRAME_PRODUCT_LINES]
    : FRAME_PRODUCT_LINES
}
